import { AppConfig } from '../../../app-config'
import { triggerSimpleAjax } from '../../../utils/http-helper'

const API_URL = AppConfig.api_url

export default () => {
	let url = `${API_URL}misc/preferredlanguages`
	return new Promise((resolve, reject) => {
		triggerSimpleAjax({
			url,
			method: 'GET',
			onSuccess: response => {
				if (response.status === 'SUCCESS') {
					resolve(response)
				}
			},
			onFailure: error => {
				reject(error)
			},
		})
	})
}
